import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { ModalForm, ProFormText, ProFormSelect } from '@ant-design/pro-form';
import { useQuery } from '@apollo/client';
import { GET_PROJECT_CATEGORIES } from 'gql/projectCategories';

const BringProjectApplicationModal = ({ onFinish, initialValues }) => {
  const formRef = useRef();
  const { data, loading } = useQuery(GET_PROJECT_CATEGORIES, {
    variables: { state: 'ACTIVE' },
  });

  const options = loading
    ? []
    : data.projectCategories.map(({ id, name }) => ({
        value: id,
        label: name,
      }));
  return (
    <ModalForm
      formRef={formRef}
      title="Bring project application to projects"
      trigger={
        <Button type="primary" style={{ marginTop: '16px' }}>
          Bring to projects
        </Button>
      }
      onFinish={async (value) => {
        await onFinish(value);
        if (formRef.current) {
          formRef.current.resetFields();
        }
        return true;
      }}
      submitter={{
        searchConfig: {
          resetText: 'Back',
          submitText: 'Submit',
        },
      }}
      initialValues={initialValues}
    >
      <ProFormText
        width="xl"
        name="title"
        label="Project Title"
        placeholder="enter project title"
        rules={[
          {
            required: true,
            message: 'Please enter project title!',
          },
        ]}
      />
      <ProFormSelect
        options={options}
        allowClear
        showSearch
        width="xl"
        name="projectCategory"
        label="Project Category"
        placeholder="select"
        rules={[
          {
            required: true,
            message: 'Please select!',
          },
        ]}
      />
    </ModalForm>
  );
};

BringProjectApplicationModal.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

export default BringProjectApplicationModal;
